import { forwardRef, ReactNode } from "react";
import {
  Accordion as ChakraAccordion,
  AccordionItemContentProps,
} from "@chakra-ui/react";

type AccordionContentStyleProps = {
  padding?: string | number;
  p?: string | number;
  paddingTop?: string | number;
  pt?: string | number;
  paddingBottom?: string | number;
  pb?: string | number;
  paddingLeft?: string | number;
  pl?: string | number;
  paddingRight?: string | number;
  pr?: string | number;
  background?: string;
  backgroundColor?: string;
  bg?: string;
  bgColor?: string;
  color?: string;
  border?: string;
  borderRadius?: string;
  display?: string;
  flexDirection?: string;
  alignItems?: string;
  overflow?: string;
};

export type AccordionContentProps = {
  children?: ReactNode;
} & AccordionContentStyleProps &
  Omit<AccordionItemContentProps, "children">;

const AccordionContent = forwardRef<HTMLDivElement, AccordionContentProps>(
  (props, ref) => {
    const {
      children,
      // Style props
      padding,
      p,
      paddingTop,
      pt,
      paddingBottom,
      pb,
      paddingLeft,
      pl,
      paddingRight,
      pr,
      background,
      backgroundColor,
      bg,
      bgColor,
      color,
      border,
      borderRadius,
      display,
      flexDirection,
      alignItems,
      overflow,
      ...rest
    } = props;

    const resolvedBg = bg ?? bgColor ?? backgroundColor ?? background;
    const resolvedPadding = p ?? padding;

    const paddingStyles = {
      ...(resolvedPadding !== undefined ? { p: resolvedPadding } : {}),
      ...(paddingTop !== undefined || pt !== undefined
        ? { pt: paddingTop ?? pt }
        : {}),
      ...(paddingBottom !== undefined || pb !== undefined
        ? { pb: paddingBottom ?? pb }
        : {}),
      ...(paddingLeft !== undefined || pl !== undefined
        ? { pl: paddingLeft ?? pl }
        : {}),
      ...(paddingRight !== undefined || pr !== undefined
        ? { pr: paddingRight ?? pr }
        : {}),
    };

    const layoutStyles = {
      ...(display !== undefined ? { display } : {}),
      ...(flexDirection !== undefined ? { flexDirection } : {}),
      ...(alignItems !== undefined ? { alignItems } : {}),
      ...(overflow !== undefined ? { overflow } : {}),
      ...(borderRadius !== undefined ? { borderRadius } : {}),
    };

    const contentProps = {
      ref,
      ...(resolvedBg !== undefined ? { bg: resolvedBg } : {}),
      ...(color !== undefined ? { color } : {}),
      ...(border !== undefined ? { border } : {}),
      ...paddingStyles,
      ...layoutStyles,
      ...rest,
    } as AccordionItemContentProps;

    return (
      <ChakraAccordion.ItemContent {...contentProps}>
        <ChakraAccordion.ItemBody p={0}>{children}</ChakraAccordion.ItemBody>
      </ChakraAccordion.ItemContent>
    );
  }
);

AccordionContent.displayName = "AccordionContent";

export default AccordionContent;
